import { Col, Modal, Rate, Row, Space, Tag, Typography } from "antd"
import React from "react"
import PdfView from "../../../../../components/custom/PDFView"

interface Props {
    selectedURL: any;
    type?: string;
}

const ResumeFeedback: React.FC<Props> = ({ selectedURL, type }) => {
    const getTagDetails = (count) => {
        if (count < 5) {
            return { text: 'Not Good', color: 'red' };
        } else if (count >= 5 && count < 7) {
            return { text: 'Average', color: 'yellow' };
        } else if (count >= 7 && count <= 8) {
            return { text: 'Good', color: 'green' };
        } else if (count >= 9) {
            return { text: 'Very Good', color: 'darkgreen' };
        }
    };

    const CountTag = ({ count }) => {
        const { text, color } = getTagDetails(count);
        return <Space><Tag bordered={false} color={color}>{text}</Tag></Space>;
    };

    return <Row gutter={[16, 16]}>
        {(!type || type == 'pdf') && <>
            {selectedURL?.url && <Col span={type == 'pdf' ? 24 : 16}><PdfView url={selectedURL?.url} /></Col>}
        </>
        }
        {(!type || type == 'rates') && <Col span={type == 'rates' ? 24 : 8}>
            {selectedURL?.skills && selectedURL?.skills.map(ele => {
                const key = Object.keys(ele)[0]
                return <Col span={24}>
                    <><div style={{ display: 'flex', justifyContent: 'space-between' }} >
                        <Typography.Title level={5}>{key} ({ele[key]}/10)</Typography.Title>
                        <CountTag count={ele[key]} />
                    </div>
                        <Rate
                            disabled
                            value={ele[key]}
                            count={10}
                        />
                    </>
                </Col>
            })}
        </Col>}
    </Row>

}

export default ResumeFeedback